// ignore-string-externalization

import styled from 'styled-components';
import {
  screenLgMin,
  screenMdMax,
  screenMdMin,
} from '@spotify-internal/encore-web-v5';
import { goldHighlight } from '../../styles/variables';

export const BlogSectionContainer = styled.div`
  .col-sidebar {
    h2 {
      margin-bottom: 25px;
    }

    h3 {
      margin-bottom: 1.25em;

      a {
        color: inherit;

        &:hover,
        &:focus {
          color: ${goldHighlight};
        }
      }
    }

    .sidebar-twitter {
      margin-top: 90px;
    }

    .affix-bottom {
      position: absolute;
    }

    .affix {
      top: 42px;
      position: fixed;

      &,
      .affix-bottom {
        width: 293.33px;

        @media (min-width: ${screenLgMin}) {
          width: 360px;
        }

        @media (max-height: 600px) {
          position: static !important;
        }
      }
    }

    @media (max-height: 750px) {
      h3:nth-child(4),
      h3:nth-child(5) {
        display: none;
      }
    }

    @media (max-height: 850px) and (max-width: ${screenMdMax}) {
      h3:nth-child(4),
      h3:nth-child(5) {
        display: none;
      }
    }
  }

  .load-more {
    margin-bottom: 70px;

    @media (min-width: ${screenMdMin}) {
      margin-bottom: 150px;
    }
  }
`;

export const BlogPostPreviewContainer = styled.div`
  padding: 0 0 56px;

  img {
    transition-property: filter;
    transition-duration: 0.3s;
    margin-left: auto;
    margin-right: auto;

    &:hover,
    &:focus {
      filter: brightness(1.1) saturate(1.1);
    }
  }

  time {
    margin: 16px 0;
  }

  h2 {
    margin-bottom: 32px;
  }

  p {
    margin-bottom: 16px;
  }
`;
